// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonShortFieldLabels = {
  code: "Code",
  identifier: "Identifier",
  name: "Name",
  description: "Description",
  createdBy: "Created By",
  createdAt: "Created At",
  updatedBy: "Updated By",
  updatedAt: "Updated At",
} as const;

export const commonShortNouns = {
  status: "Status",
  actions: "Actions",
} as const;
